import Navbar from "../component/landingPage/navigation/Navbar";
import Footer from "../component/common/Footer";
import "../asset/sass/global.scss";
import background from "../asset/lotties/bg1.json";
import Lottie from "lottie-react";
import styles from "./About.module.scss";

export default function About() {
  return (
    <>
      <header className={`${styles["new-header"]} header`}>
        <div className="hero-overlay">
          <Lottie animationData={background} className="backgroundImage" />
        </div>
        <Navbar />
        <main className={styles["about-section"]}>
          <div className={styles["about-section__wrapper"]}>
            <h1 className={styles["about-section__title"]}>
              About <span className={styles["text-purple"]}>PLAYBOX</span>
            </h1>
            <div className={styles["about-section__content"]}>
              <div className={styles["about-section__description"]}>
                <h2>Building the Future of UI Development</h2>
                <p>
                  PLAYBOX is a revolutionary UI component library designed to
                  streamline the development process for designers and
                  developers alike. Our mission is to eliminate the tedious
                  setup and configuration that often slows down creative
                  workflows.
                </p>
                <h3>What Makes Us Different</h3>
                <ul>
                  <li>
                    <strong>Zero Setup Required:</strong> Start building
                    immediately without complex configurations
                  </li>
                  <li>
                    <strong>Customizable Components:</strong> Every component is
                    fully customizable to match your design system
                  </li>
                  <li>
                    <strong>Save & Share:</strong> Save your custom components
                    and share them with your team
                  </li>
                  <li>
                    <strong>Modern Design:</strong> Built with the latest design
                    principles and accessibility standards
                  </li>
                </ul>
              </div>
              <div className={styles["about-section__stats"]}>
                <div className={styles["stat-item"]}>
                  <h4>50+</h4>
                  <p>Components</p>
                </div>
                <div className={styles["stat-item"]}>
                  <h4>10+</h4>
                  <p>Languages</p>
                </div>
                <div className={styles["stat-item"]}>
                  <h4>24/7</h4>
                  <p>Support</p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </header>
      <Footer />
    </>
  );
}
